import http, { url } from '../../../http'

const API_URL = "copasst-candidate"

class CandidatesCopasstAPI {

  async saveCandidate(candidate) {
    const response = await http(`${API_URL}/save`, 'POST', candidate)
    return response
  }

  async save(candidates) {
    const response = await http(`${API_URL}/multi-save`, 'POST', {
      candidates: candidates
    })
    return response
  }

  async updateCandidate(candidateID, candidate) {
    const response = await http(`${API_URL}/update/${candidateID}`, 'PUT', candidate)
    return response
  }

  async getAllPossibleCandidates(companyID) {
    const { copasst_act } = await http(`${API_URL}/show/${companyID}`, 'GET')
    return copasst_act || null
  }
 /*async getAllPossibleCandidates() {
    const { copasst_act } = await http(`${API_URL}/show`, 'GET')
    return copasst_act || null
  }*/

  async updateTraining(candidateID, file) {
    const response = await http(`${API_URL}/update-url-training/${candidateID}`, 'PUT', {
      training_copasst_url: file
    })
    return response
  }

}

export default new CandidatesCopasstAPI()